import { useEffect } from 'react';
import { getGoogleAnalyticsId, getGoogleAdsId } from '../utils/apiConfig';

/**
 * Component to dynamically load tracking scripts based on API configurations
 */
const TrackingScripts = () => {
  useEffect(() => {
    const loadTrackingScripts = async () => {
      // Load Google Analytics
      const gaId = await getGoogleAnalyticsId();
      if (gaId) {
        // Remove existing GA script if any
        const existingGA = document.getElementById('google-analytics-script');
        if (existingGA) {
          existingGA.remove();
        }

        // Add Google Analytics gtag script
        const scriptGA = document.createElement('script');
        scriptGA.id = 'google-analytics-script';
        scriptGA.async = true;
        scriptGA.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
        document.head.appendChild(scriptGA);

        // Initialize gtag
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          window.dataLayer.push(arguments);
        }
        window.gtag = gtag;
        gtag('js', new Date());
        gtag('config', gaId);
      }

      // Load Google Ads
      const adsId = await getGoogleAdsId();
      if (adsId) {
        // Remove existing Google Ads script if any
        const existingAds = document.getElementById('google-ads-script');
        if (existingAds) {
          existingAds.remove();
        }

        // Add Google Ads conversion script
        const scriptAds = document.createElement('script');
        scriptAds.id = 'google-ads-script';
        scriptAds.async = true;
        scriptAds.src = `https://www.googletagmanager.com/gtag/js?id=${adsId}`;
        document.head.appendChild(scriptAds);

        // Initialize Google Ads
        if (!window.dataLayer) {
          window.dataLayer = [];
        }
        function gtag() {
          window.dataLayer.push(arguments);
        }
        if (!window.gtag) {
          window.gtag = gtag;
          gtag('js', new Date());
        }
        gtag('config', adsId);
      }
    };

    loadTrackingScripts();
  }, []);

  return null; // This component doesn't render anything
};

export default TrackingScripts;

